/* global $, data, query_string, pitch_types */
/* eslint-disable no-use-before-define */
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'runs'
const careerSecHeaderOffset = query_string.year === 'Career' ? 1 : 0

$(document).ready(() => {
    $('form').submit(false)

    $('#ddlSubType').change(() => {
        $('#lblSubType').html($('#ddlSubType option:selected').text())
    })

    $('#ddlType').change(() => {
        if ($('#ddlType').val() !== 'All') {
            populateSubTypes($('#ddlType').val())
        } else {
            $('#ddlSubType').empty()
            $('#divSubType').hide()
        }
    })

    function populateSubTypes(type) {
        $('#divSubType').show()
        $('#ddlSubType').empty()
        if (type === 'Swing-Take') {
            $('#lblSubType').html('Swing')
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'Swing',
                    text: 'Swing',
                })
            )
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'Take',
                    text: 'Take',
                })
            )
        }
        if (type === 'Pitch Type') {
            $('#lblSubType').html('4-Seam Fastball')
            pitch_types.forEach((pitchType) =>
                $('#ddlSubType').append(
                    $('<option>', {
                        value: pitchType.pitch_name,
                        text: pitchType.pitch_name,
                    })
                )
            )
        }
        if (type === 'Attack Region') {
            $('#lblSubType').html('Heart')
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'Heart',
                    text: 'Heart',
                })
            )
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'Shadow',
                    text: 'Shadow',
                })
            )
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'Chase',
                    text: 'Chase',
                })
            )
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'Waste',
                    text: 'Waste',
                })
            )
        }
        if (type === 'Bat-side') {
            $('#lblSubType').html('R')
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'R',
                    text: 'R',
                })
            )
            $('#ddlSubType').append(
                $('<option>', {
                    value: 'L',
                    text: 'L',
                })
            )
        }
    }

    if (query_string.sub_type && query_string.sub_type !== 'null') {
        populateSubTypes($('#ddlType').val())
        $('#ddlSubType').val(query_string.sub_type).attr('selected', true)
        $('#lblSubType').html($('#ddlSubType option:selected').text())
    }

    if (data && data.length > 0) {
        const dataLoad = data

        const headers = [
            {
                name: 'Player',
                field: 'link',
                customSortField: 'player_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'player_id',
            },
            {
                name: 'Team',
                field: 'team_name_abbrev',
                headerClass: `th-component-header ${
                    query_string.year === 'Career' ? 'hidden' : ''
                }`,
                fieldClass: `tr-data ${
                    query_string.year === 'Career' ? 'hidden' : ''
                }`,
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: true,
            },
            {
                name: 'Year',
                field: 'year',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (d) =>
                    query_string.year === 'Career' ? 'Career' : d,
            },
            {
                name: 'PA',
                field: 'pa',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                defaultSortDir: 'desc',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'Pitches',
                field: 'pitches',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                defaultSortDir: 'desc',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'Heart',
                field: 'runs_heart',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: (val) => guff(val, 'run_value'),
            },
            {
                name: 'Shadow',
                field: 'runs_shadow',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'run_value'),
            },
            {
                name: 'Chase',
                field: 'runs_chase',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'run_value'),
            },
            {
                name: 'Waste',
                field: 'runs_waste',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'run_value'),
            },
            {
                name: 'All',
                field: 'runs_all',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                highlightDynamic: true,
                displayFn: (val) => guff(val, 'run_value'),
            },
        ]

        if (query_string.type === 'Attack Region') {
            let headerIndex = 4
            for (let i = 0; i < pitch_types.length; i++) {
                headers[headerIndex] = {
                    name:
                        pitch_types[i].pitch_name === '4-Seam Fastball'
                            ? '4-Seam<br />Fastball'
                            : pitch_types[i].pitch_name,
                    field: `runs_${pitch_types[
                        i
                    ].pitch_type_group.toLowerCase()}`,
                    type: 'number',
                    headerClass:
                        headerIndex === 4
                            ? 'th-component-header border-left'
                            : 'th-component-header',
                    fieldClass:
                        headerIndex === 4 ? 'tr-data border-left' : 'tr-data',
                    displayFn: (val) => guff(val, 'run_value'),
                }
                headerIndex += 1
            }
            headers.push({
                name: 'All',
                field: 'runs_all',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                highlightDynamic: true,
                displayFn: (val) => guff(val, 'run_value'),
            })
        }

        if (query_string.leverage === 'Leveraged') {
            headers.push({
                name: '+/- Due To<br />Leverage',
                field: 'delta_runs',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                highlight: [-10, 0, 10],
                displayFn: (val) => guff(val, 'run_value'),
            })
        }

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        let defaultSort = 'runs_all'
        const defaultSortDirection = 'desc'

        if (query_string.sort !== undefined) {
            const { customSortField, field } = headers[query_string.sort] || {}
            defaultSort = customSortField || field || 'runs_all'
        }

        // eslint-disable-next-line no-new, new-cap
        new Table({
            id: 'runs',
            repeatHeader: repeatHeaders,
            sortClass: 'column-sort',
            secondaryHeaders: [
                {
                    name: '',
                    colspan:
                        (query_string.type === 'Attack Region' ? 5 : 6) -
                        careerSecHeaderOffset,
                    headerClass: 'th-name-header',
                },
                {
                    name: `Runs${
                        query_string.leverage === 'Leveraged'
                            ? ' (Leveraged)'
                            : ''
                    }`,
                    colspan: pitch_types.length,
                    headerClass: 'th-title-header',
                },
                {
                    name: '',
                    colspan:
                        (query_string.type === 'Attack Region' ? 3 : 1) -
                        careerSecHeaderOffset,
                    headerClass:
                        query_string.type === 'Attack Region'
                            ? 'th-title-header'
                            : 'th-name-header',
                },
            ],
            headers,
            data: dataLoad,
            defaultSort,
            defaultSortDirection,
            initialSortDirection: query_string.sortDir || defaultSortDirection,
            showRank: true,
            sortCallback(_, sortCol, header) {
                window.history.replaceState(
                    {},
                    '',
                    populateUrl(sortCol, header.state)
                )
            },
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function handleEach() {
                    const rowWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++ // eslint-disable-line
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function handleEach() {
                    const rowWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++ // eslint-disable-line
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    $('#btnUpdate').click(() => {
        window.location.href = `/leaderboard/swing-take${populateUrl()}`
    })

    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/swing-take${populateUrl()}&csv=true`
    })

    $(document).on('click', 'th.th-component-header', () => {
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
    })
})

function populateUrl(sortCol, sortDir) {
    const sortColParam = sortCol ? `&sort=${sortCol}` : ''
    const sortDirParam = sortCol ? `&sortDir=${sortDir}` : ''
    return `?year=${$('#ddlSeason').val()}&team=${$(
        '#ddlTeam'
    ).val()}&leverage=${$('#ddlLeverage').val()}&group=${$(
        '#ddlGroup'
    ).val()}&type=${$('#ddlType').val()}&sub_type=${$(
        '#ddlSubType'
    ).val()}&min=${$('#ddlMin').val()}${sortColParam}${sortDirParam}`
}

document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target[selectedIndex].text
    })
})
